<template>
  <div>
    <shop-head currentPageName="company"></shop-head>
    <div class="content_wrapper">
      <div class="container">
        <div class="content">
          <div class="companyList">
            <div class="premium">
              <el-carousel height="300px">
                <el-carousel-item
                  v-for="item in banndersList"
                  :key="item.image"
                >
                  <img :src="item.image" alt="" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="search">
              <el-form :inline="true" :model="search" class="demo-form-inline">
                <el-form-item label="">
                  <el-cascader
                    :options="address"
                    @change="addSel"
                    :placeholder="$t('所在地区')"
                    :show-all-levels="false"
                    filterable
                    clearable
                    :props="{
                      value: 'code',
                      label:
                        this.$cookie.get('language') == 'zh'
                          ? 'name'
                          : 'nameSpell',
                    }"
                  ></el-cascader>
                  <!-- <el-select v-model="search.companyName" placeholder="所在地区">
                    <el-option v-for="item in address" :key="item.label" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="search.type"
                    :placeholder="$t('企业类型')"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in types"
                      :key="item.label"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="search.carType"
                    @change="findChildsByKey(search.carType)"
                    :placeholder="$t('车系')"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in carTypes"
                      :key="item.note"
                      :label="lang == 'zh' ? item.note : item.keyS"
                      :value="item.note"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="search.brands"
                    :placeholder="$t('品牌')"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in brands"
                      :key="item.note"
                      :label="lang == 'zh' ? item.note : item.keyS"
                      :value="item.keyS"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="search.companyName"
                    :placeholder="$t('企业名称')"
                    size="normal"
                    clearable
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="">
                  <el-select v-model="search.companyName" placeholder="">
                    <el-option v-for="item in []" :key="item.label" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item> -->
              </el-form>
            </div>
            <div class="companys">
              <el-row
                :gutter="20"
                v-for="item in companyList"
                :key="item.id"
                style="
                  background-color: #fff;
                  margin: 10px;
                  border-radius: 5px;
                  padding: 20px 5px;
                  cursor: pointer;
                "
              >
                <div
                  @click="goDetail(item)"
                  style="display: flex; align-items: center"
                >
                  <el-col :span="19" :offset="0">
                    <h2>{{ item.companyName }}</h2>
                    <el-tag
                      style="margin: 10px 20px 10px 0"
                      v-for="item in item.labelNames
                        ? item.labelNames.split(',')
                        : ['空']"
                      :key="item"
                      >{{ $t(item) }}</el-tag
                    >
                    <!-- <el-tag style="margin-right: 20px;">国营企业</el-tag> -->
                    <!-- <el-tag style="margin-right: 20px;">收录6年</el-tag> -->
                    <br />
                    <div
                      style="
                        color: #9b9b9b;
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        margin: 10px 0px;
                      "
                    >
                      <span
                        >{{ $t("所在地区") }}: {{ item.provinceName
                        }}{{ item.areaName || $t("未知") }}</span
                      >
                      <span>{{ $t("注册资金") }}: {{ $t("未知") }}</span>
                      <span
                        >{{ $t("成立时间") }}:
                        {{ item.createTime | formatDate }}</span
                      >
                    </div>
                    <label style="color: #1a689a">{{ $t("主营产品") }}: </label>
                    <span>{{ item.category || $t("未知") }}</span>
                    <br />
                    <label style="color: #1a689a">{{ $t("配套客户") }}: </label>
                    <span>{{ item.brand || $t("未知") }}</span>
                  </el-col>
                  <el-col :span="5" :offset="0">
                    <img
                      v-if="item.logo"
                      style="width: 100%; height: 147px"
                      :src="item.logo"
                      alt=""
                    />
                    <img
                      v-else
                      style="
                        width: 100%;
                        height: 147px;
                        filter: grayscale(100%) opacity(30%);
                      "
                      src="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh01df1e9a3c204a749535c28d219af1e6deflault_load.0accee0d.png"
                      alt=""
                    />
                  </el-col>
                </div>
              </el-row>
            </div>
            <br />
            <br />
            <el-pagination
              background
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleChangeSize"
              @current-change="handleSearch"
            />
          </div>
          <div class="hots">
            <h2 style="border-bottom: 3px solid #184d7f;margin: 10px 0px;">
              {{ $t("视频头条") }}
            </h2>
            <el-row
              :gutter="20"
              v-for="item in newsList"
              :key="item.id"
              style="
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 0px solid #c7c3c3;
              "
            >
              <div @click="gotoDetail(item)">
                <b style="padding: 0px 10px; display: block">{{ item.name }}</b>
                <el-col :span="10" :offset="0">
                  <img
                    style="width: 100%; height: 100px"
                    :src="item.images"
                    alt=""
                /></el-col>
                <el-col :span="14" :offset="0">
                  <p>{{ item.details }}</p>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import {
  companyList,
  companyDetail,
  addressAll,
  findChildsByKey,
  homePageBanner,
} from "../../apis/company";
import { getnewsList } from "../../apis/qpgtt";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  filters: {
    formatDate(time) {
      return time ? new Date(time).toLocaleString().split(" ")[0] : "--";
    },
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      type: "资讯",
      addressSel: "",
      address: [],
      types: [
        { label: this.$i18n.t("工厂"), value: "1" },
        { label: this.$i18n.t("汽配品牌商"), value: "2" },
        { label: this.$i18n.t("维修厂/连锁"), value: "3" },
        { label: this.$i18n.t("其他"), value: "4" },
      ],
      carTypes: [],
      brands: [],
      search: {
        companyName: "",
        type: "",
        carType: "",
        brand: "",
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        currentPage: 1,
        pageSize: 10,
      },
      companyList: [],
      newsList: [],
      banndersList: [],
    };
  },
  watch: {
    search: {
      handler(newVal, oldVal) {
        this.getList();
      },
      deep: true, // 深度监听
    },
  },
  created() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    this.search.companyName =
      this.$route.query.title || this.$route.query.companyName || "";
    this.getList();
    this.findChildsByKey();
    addressAll().then((res) => {
      this.address = res.data;
    });
  },
  methods: {
    async findChildsByKey(e) {
      this.brands = [];
      const keyS = this.carTypes.find((item) => item.note == e) || { keyS: "" };
      try {
        if (e) {
          this.brands = (await findChildsByKey({ key: keyS.keyS })).data;
        } else {
          this.carTypes = (await findChildsByKey({ key: "Cars" })).data;
        }
      } catch (err) {}
    },
    goDetail(data) {
      this.$router.push({
        path: "/companyDetail",
        query: data,
      });
    },
    addSel(e) {
      this.search.provinceCode = e[0];
      this.search.cityCode = e[1];
      this.search.areaCode = e[2];
    },
    typeChange(e) {
      this.search.type = { 资讯: "1", 视频: "2" }[e];
      this.getList();
    },
    async getList() {
      this.newsList = (await getnewsList(this.search)).data.list;
      this.banndersList = (await homePageBanner({ showTheLocation: 3 })).data;
      const { total, list } = (await companyList(this.search)).data;
      this.companyList = list;
      this.total = total;
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.search.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.getList();
    },
    /** 跳转详情 */
    gotoDetail(data) {
      this.$router.replace({
        path: "/newsDetail",
        query: data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding: 0px 0 20px 0;
  margin-top: 10px;

  ::v-deep .el-radio-button__inner {
    font-size: 16px;
    padding: 15px 275px;
  }

  .content {
    display: flex;
    // height: 1500px;

    .companyList {
      width: 70%;
      // padding: 10px;
      // border-right: 1px solid #c7c3c3;
      display: flex;
      flex-direction: column;
      align-items: center;

      .premium {
        margin-bottom: 20px;
        width: 100%;

        .el-carousel__item img {
          width: 100%;
          height: 100%;
          line-height: 300px;
          margin: 0;
        }
      }
    }

    .search {
      width: 100%;

      // background-color: #c7c3c3;
      ::v-deep .el-form--inline .el-form-item__content {
        width: 149px;
      }

      .demo-form-inline {
        // height: 40px;
        margin: 10px 0px 0px 10px;
        background-color: #fff;
      }
    }

    .companys {
      // overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
      background-color: #e3e6eb;

      h2 {
        font-weight: 600;
      }

      .el-tag {
        color: #045991;
        height: 24px;
        line-height: 24px;
        font-weight: 550;
      }
    }

    .hots {
      width: 30%;
      padding-left: 5px;
      overflow-x: hidden;
      // overflow-y: auto;
    }
  }
}
</style>